import moment from 'moment';

export const AWAITING_ENROLLMENT_STATUSES = ['FOR_APPROVAL', 'BLOCKED', 'DENIED'];

export const ACTIVE_ENROLLMENT_STATUSES = ['ENROLLED', 'ENROLLED_NOT_STARTED'];

export const isAwaitingEnrollment = (kidStatus?: string | null): boolean =>
  AWAITING_ENROLLMENT_STATUSES.includes(String(kidStatus || ''));

export const initialClassId = (kidStatus?: string | null, enrollment?: any): string => {
  if (isAwaitingEnrollment(kidStatus) && enrollment?.requestedClassId) {
    return String(enrollment.requestedClassId);
  }
  return enrollment?.classId ? String(enrollment.classId) : '';
};

export const willEnroll = (classId?: string | null, enrollmentStatus?: string | null): boolean =>
  !!classId && ACTIVE_ENROLLMENT_STATUSES.includes(String(enrollmentStatus || ''));

export const formatDesiredStartDate = (potentialDate?: string | null): string =>
  potentialDate ? moment.utc(potentialDate).format('MM/DD/YYYY') : '';
